import React, { useState, useEffect } from 'react';
import '../../css/Pages.css';
import OtherResearchContentListing from '../../components/CategoryManagement/OtherResearchContent/OtherResearchContentListing';
import OtherResearchContentForm from '../../components/CategoryManagement/OtherResearchContent/OtherResearchContentForm';
import { useConfirmDeleteDialog } from '../../hooks/useConfirmDeleteDialog';
import { useCloseConfirmDialog } from '../../hooks/useCloseConfirmDialog';

const OtherResearchContent = () => {
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    const filteredData = data.filter(item =>
        item.Name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const [isLoading, setIsLoading] = useState(true);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [name, setName] = useState('');
    const [score, setScore] = useState(0);
    const [editId, setEditId] = useState(null);

    const [isDesktop, setIsDesktop] = useState(true);

    const { confirmDeleteDialog } = useConfirmDeleteDialog();
    const { confirmCloseDialog } = useCloseConfirmDialog();

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => { fetchData(); }, []);

    const fetchData = async () => {
        setIsLoading(true);
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const response = await fetch(`${API_BASE_URL}/otherresearchcontent`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                const result = await response.json();
                if (Array.isArray(result)) {
                    setData(result);
                } else {
                    console.error("Lỗi: Dữ liệu API trả về không phải là mảng", result);
                    setData([]);
                }
            } else {
                console.error("Lỗi HTTP:", response.status);
                setData([]);
            }
        } catch (error) {
            console.error("Lỗi:", error);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
    };

    const handleEdit = (item) => {
        setEditId(item.Id);
        setName(item.Name);
        setScore(item.Score);
        setIsModalOpen(true);
    };

    const handleDelete = (id) => {
        confirmDeleteDialog({
            header: 'Xác nhận xóa',
            message: 'Bạn có chắc chắn muốn xóa nội dung NCKH này không?',
            accept: async () => {
                try {
                    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
                    const response = await fetch(`${API_BASE_URL}/otherresearchcontent?id=${id}`, {
                        method: 'DELETE',
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });

                    if (response.status === 401 || response.status === 403) {
                        localStorage.removeItem('user');
                        localStorage.removeItem('accessToken');
                        window.location.href = '/login';
                        return;
                    }

                    if (response.ok) {
                        fetchData();
                    } else {
                        alert("Xóa thất bại! Vui lòng kiểm tra lại quyền truy cập.");
                    }
                } catch (error) {
                    console.error("Lỗi xóa:", error);
                }
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
            const method = editId ? 'PUT' : 'POST';
            const body = { Name: name, Score: parseFloat(score) };
            if (editId) body.Id = editId;

            const response = await fetch(`${API_BASE_URL}/otherresearchcontent`, {
                method,
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('user');
                localStorage.removeItem('accessToken');
                window.location.href = '/login';
                return;
            }

            if (response.ok) {
                fetchData();
                closeModal();
            } else {
                alert("Lưu thất bại! Vui lòng kiểm tra lại quyền truy cập.");
            }
        } catch (error) {
            console.error("Lỗi lưu:", error);
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setName('');
        setScore(0);
        setEditId(null);
    };

    return (
        <div className="page-container">
            <div
                className="page-header"
                style={isDesktop ? { marginBottom: '10px' } : { marginBottom: '10px', display: 'flex', flexDirection: 'column', gap: '10px' }}
            >
                <div className="header-title">
                    <h2 style={isDesktop ? {} : { margin: 0 }}>DANH MỤC NỘI DUNG NCKH KHÁC</h2>
                </div>
                <button
                    className="btn-add-new"
                    onClick={() => { setEditId(null); setName(''); setScore(0); setIsModalOpen(true); }}
                    style={isDesktop ? {} : { width: '100%', margin: 0 }}
                >
                    <i className="fa-solid fa-plus"></i> Thêm mới
                </button>
            </div>

            <div style={isDesktop
                ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', marginTop: '10px' }
                : { display: 'flex', flexDirection: 'column', gap: '15px', marginBottom: '20px', marginTop: '10px' }
            }>
                <p className="sub-title" style={{ margin: 0 }}>DANH SÁCH NỘI DUNG NCKH</p>

                <div style={isDesktop
                    ? { display: 'flex', gap: '10px' }
                    : { display: 'flex', gap: '10px', width: '100%', alignItems: 'stretch' }
                }>
                    <div style={isDesktop ? { position: 'relative' } : { position: 'relative', flex: 1 }}>
                        <i className="fa-solid fa-magnifying-glass" style={{ position: 'absolute', left: '12px', top: '12px', color: '#888' }}></i>
                        <input
                            type="text"
                            placeholder="Tìm kiếm nội dung"
                            className="form-input"
                            style={isDesktop
                                ? { width: '300px', padding: '10px 15px 10px 35px', borderRadius: '6px', border: '1px solid #ccc' }
                                : { width: '100%', padding: '10px 15px 10px 35px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', height: '100%' }
                            }
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                    </div>
                    <button
                        onClick={fetchData}
                        className="btn-add-new"
                        style={isDesktop
                            ? { margin: 0, padding: '10px 15px', backgroundColor: '#6c757d' }
                            : { margin: 0, padding: '0', width: '45px', flex: '0 0 45px', backgroundColor: '#6c757d', display: 'flex', justifyContent: 'center', alignItems: 'center' }
                        }
                        title="Tải lại dữ liệu"
                    >
                        <i className="fa-solid fa-rotate-right"></i>
                    </button>
                </div>
            </div>

            <OtherResearchContentListing
                data={filteredData}
                onEdit={handleEdit}
                onDelete={handleDelete}
                isLoading={isLoading}
                searchQuery={searchQuery}
            />

            <OtherResearchContentForm
                isOpen={isModalOpen}
                onClose={() => (name.trim() !== '' ? confirmCloseDialog(closeModal) : closeModal())}
                onSubmit={handleSubmit}
                name={name} setName={setName}
                score={score} setScore={setScore}
                isEditing={!!editId}
            />
        </div>
    );
};

export default OtherResearchContent;